import React from "react";
import styles from "./BniLoadingSpinner.module.css";

const BniLoadingSpinner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.ringOuter}></div>
      <div className={styles.ringInner}></div>

      <img
        src="/images/bniRedGreyLogo.png"
        alt="BNI Brisk"
        className={styles.logo}
      />

      <div className={styles.loadingText}>Loading…</div>
    </div>
  );
};

export default BniLoadingSpinner;
